define(function (require) {
    "use strict";

    var LE = require("app");
    var Page = require("ui.components/page/Page");
    var ErrorCodes = require("codeTables/errorCodes.json");
    var AppInstallEditView = require("manager-views/data-sources/app-install/AppInstallEditView");
    var AppInstallModel = require("models/entities/AppInstallModel");

    var AppInstallEditController = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {

        AppInstallEditController = Marionette.Controller.extend({
            pageView: null,
            insideView: null,
            needToRenderView: true,

            initialize: function(options) {
                this._initialize(options);
            },

            _initialize: function(options) {
                LEManager.logger.debug("AppInstallEditController:_initialize");
                this.channel = LEManager.media.channel("conversationSources");
                this.softwaresCollection = LEManager.getModuleDataManager().getSoftwaresCollection();
                this.appInstallsCollection = LEManager.getModuleDataManager().getAppInstallsCollection();
                this.appInstallModel = null;
                this._bindEvents();
            },

            _bindEvents: function(){
                LEManager.logger.debug("call of _bindEvents","AppInstallEditController:_bindEvents");
                this.listenTo(this.channel, "appInstall:save", this._onAppInstallSave);
                this.listenTo(this.channel, "appInstall:change:description", this._onAppInstallDescriptionChange);
                this.listenTo(this.channel, "appInstall:change:enabled", this._onAppInstallEnabledChange);
                this.listenTo(this.channel, "appInstall:change:name", this._onAppInstallNameChange);
                this.listenTo(this.channel, "appInstall:change:logoUri", this._onAppInstallLogoUriChange);
                this.listenTo(this.channel, "appInstall:cancel:click", this._onAppInstallClose);
                this.listenTo(this.channel, "appInstall:logo:preview:updated", this._onLogoPreviewUpdated);
            },

            getMainView: function() {
                return this._getMainView();
            },

            showAppInstallEdit: function(softwareId, appInstallId) {
                this._showAppInstallEdit(softwareId, appInstallId);
            },

            _showAppInstallEdit: function(softwareId, appInstallId) {
                if (!this.needToRenderView) {
                    this.needToRenderView = true;
                    return;
                }

                LEManager.showLoader();

                //this.softwareModel = this.softwaresCollection.get(softwareId); //for some reason this does not work because the idAttribute points to a nested attribute. TODO: Check
                this.softwareModel = this.softwaresCollection.findSoftwareModelById(softwareId);

                if (!_.isUndefined(this.softwareModel)){
                    if (appInstallId === LE.CONST.ROUTING.NEW_ITEM_ID) {
                        var softwareAlreadyInstalled = this.appInstallsCollection.getAppInstallModelBySoftwareId(softwareId).length > 0;
                        if (!softwareAlreadyInstalled) {
                            this._createNewAppInstall();
                        }
                        else {
                            this._handleError(LE.translator.translate("LEManager.dataSources.conversationSources.appInstallEdit.applicationAlreadyInstalled"));
                        }
                    }
                    else {
                        this._fetchAppInstall(appInstallId);
                    }
                }
                else { //its likely someone has edited the software id in the url. navigate back.
                    this._handleError(LE.translator.translate("LEManager.dataSources.conversationSources.appInstallEdit.errorOnFetching.noDataFound"));
                }
            },

            _handleError: function(errorMessage){
                LEManager.closeLoader();
                LEManager.notifier.showError({
                    content: errorMessage,
                    timeToShow: 6000});
                LEManager.router.navigateBack();
            },

            _createNewAppInstall: function() {
                LEManager.logger.debug("call of _createNewAppInstall - softwareId: " + this.softwareModel.getSoftwareId(),"AppInstallEditController:_createNewAppInstall");
                var appInstallData = {};
                appInstallData[AppInstallModel.KEYS.CLIENT_NAME] = this.softwareModel.getName();
                appInstallData[AppInstallModel.KEYS.SOFTWARE_STATEMENT] = this.softwareModel.getSoftwareStatement();
                appInstallData[AppInstallModel.KEYS.LOGO_URI] = this.softwareModel.getLogoUri();
                appInstallData[AppInstallModel.KEYS.CAPABILITIES] = this.softwareModel.getCapabilities();
                this.appInstallModel = new AppInstallModel(appInstallData);
                this._showView();
            },

            _fetchAppInstall: function(appInstallId) {
                LEManager.logger.debug("call of _fetchAppInstall - softwareId: " + this.softwareModel.getSoftwareId() + " - appInstallId: " + appInstallId,"AppInstallEditController:_fetchAppInstall");
                this.appInstallModel = new AppInstallModel({client_id: appInstallId});
                this.appInstallModel.fetch({
                    success: _.bind(this._onAppInstallFetchSuccess, this),
                    error: _.bind(this._onAppInstallFetchError, this)
                });
            },

            _onAppInstallFetchSuccess: function(model, response, options) {
                this._showView();
            },

            _onAppInstallFetchError: function(model, response, options) {
                var errorMessage = LE.translator.translate("LEManager.dataSources.conversationSources.appInstallEdit.errorOnFetching.text");
                if (response && response.responseError) {
                    if (response.responseError.internalCode == ErrorCodes.noDataFound) {
                        errorMessage = LE.translator.translate("LEManager.dataSources.conversationSources.appInstallEdit.errorOnFetching.noDataFound");
                    } else if (!_.isEmpty(response.responseError.message)) {
                        errorMessage = response.responseError.message;
                    }
                }
                this._handleError(errorMessage);
            },

            _showView: function() {
                LEManager.logger.debug("call of _showView - softwareId: " + this.softwareModel.getSoftwareId() + " - appInstallId: " + this.appInstallModel.id,"AppInstallEditController:_showView");
                var pageTitleKey = this.appInstallModel.isNew() ? "LEManager.dataSources.conversationSources.appInstallEdit.title.new" : "LEManager.dataSources.conversationSources.appInstallEdit.title.edit";
                var pageTitle = LE.translator.translate({
                    key: pageTitleKey,
                    args: [{key: this.softwareModel.getName()}]
                });

                this.appInstallModel.setSoftwareLogoUri(this.softwareModel.getLogoUri());
                this.insideView = new AppInstallEditView({model: this.appInstallModel, softwareModel: this.softwareModel});
                this.pageView.setTitle(pageTitle);
                this.pageView.setInsideView(this.insideView);
                LEManager.closeLoader();
            },

            _onAppInstallSave: function(){
                this.listenTo(this.appInstallModel, "invalid", this._onSaveInvalid);
                var isCreateNewAppInstall = this.appInstallModel.isNew();
                this.appInstallModel.save(null, {
                    success: _.bind(isCreateNewAppInstall ? this._onAppInstallCreateSuccess : this._onAppInstallSaveSuccess, this),
                    error: _.bind(isCreateNewAppInstall ? this._onAppInstallCreateError : this._onAppInstallSaveError, this)
                });
            },

            _onLogoPreviewUpdated: function() {
                var errorObj = {};
                var error = this.appInstallModel.preValidate(AppInstallModel.KEYS.LOGO_URI, this.appInstallModel.getLogoUri());
                if (error) {
                    errorObj[AppInstallModel.KEYS.LOGO_URI] = LE.translator.translate(error);
                    this.channel.trigger("appInstall:logo:preview:error", errorObj);
                }
            },

            _onAppInstallDescriptionChange: function(description){
                this.appInstallModel.setDescription(description);
            },

            _onAppInstallEnabledChange: function(enabled){
                this.appInstallModel.setEnabled(enabled);
            },

            _onAppInstallLogoUriChange: function(logo_uri){
                this.appInstallModel.setLogoUri(logo_uri);
            },

            _onAppInstallNameChange: function(name){
                this.appInstallModel.setName(name);
            },

            _onAppInstallCreateSuccess: function(model, resp, options) {
                this.needToRenderView = false;
                var msg = LE.translator.translate("LEManager.dataSources.conversationSources.appInstallEdit.create.success");
                this._afterSave();
                LEManager.notifier.showSuccess(msg);
                LEManager.router.navigateNonBackable("data/sources/" + this.softwareModel.getSoftwareId() + "/" + model.id, {replace:true});
            },

            _onAppInstallCreateError: function(model, resp, options) {
                var msg = LE.translator.translate("LEManager.dataSources.conversationSources.appInstallEdit.create.error");
                this._afterSave();
                if (resp && _.has(resp, "responseError") ) {
                    if (resp.responseError.internalCode === ErrorCodes.dependencyConflict){
                        msg = LE.translator.translate("LEManager.dataSources.conversationSources.appInstallEdit.create.dependency.conflict");
                    } else if (resp.responseError.internalCode === ErrorCodes.duplicateEntity) {
                        msg = LE.translator.translate("LEManager.dataSources.conversationSources.appInstallEdit.create.duplicated");
                    }
                }
                LEManager.notifier.showError(msg);
            },

            _onAppInstallSaveSuccess: function(model, resp, options){
                LEManager.logger.info("AppInstall save success: client_id: " + model.id + " - AppInstallEditController:_onAppInstallSaveError", model);
                var msg = LE.translator.translate("LEManager.dataSources.conversationSources.appInstallEdit.save.success");
                LEManager.notifier.showSuccess(msg);
                this._afterSave();
                LEManager.router.navigateBack();
            },

            _onAppInstallSaveError: function(model, resp, options){
                LEManager.logger.error("AppInstall save error - AppInstallEditController:_onAppInstallSaveError", model);
                var msg = LE.translator.translate("LEManager.dataSources.conversationSources.appInstallEdit.save.error");
                if (resp && resp.responseError && resp.responseError.message) {
                    msg = resp.responseError.message;
                }
                this._afterSave();
                LEManager.notifier.showError(msg);
            },

            _onSaveInvalid: function() {
                var msg = LE.translator.translate("LEFramework.errors.generalError.on.page");
                this._afterSave();
                LEManager.notifier.showError(msg);
            },

            _afterSave: function() {
                this.stopListening(this.appInstallModel, "invalid");
                LEManager.closeLoader();
            },

            _getMainView: function() {
                LEManager.logger.debug("AppInstallEditController:getMainView - started");

                this._initPageComponent();
                return this.pageView;
            },

            _initPageComponent: function(){
                LEManager.logger.debug ("AppInstallEditController:_initPageComponent");
                if (this.needToRenderView) {
                    if (this.pageView) {
                        this.pageView.close();
                    }
                    this.pageView = new Page({
                        moduleName:LEManager.moduleName,
                        context:LE.context,
                        hasActionStrip: false
                    });
                }
            },

            _onAppInstallClose: function() {
                LEManager.router.navigateBack();
            }

        });

    }

    LE.module("LEManager", moduleDefinition);

    return AppInstallEditController;
});
